/**
 * Two-person "users" glyph, matching the prototype's adoption signal icon
 * (poc-site/public/pocs/ai-marketplace/index.html, `adoptionInline`).
 *
 * Uses currentColor rather than the prototype's hard-coded #6b7280 so it inherits the
 * signal row's colour and follows the light/dark tokens.
 */
export default function UsersIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      {...props}
    >
      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
      <circle cx="9" cy="7" r="4" />
      <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
    </svg>
  );
}
